import { MessageAnalysesModel } from 'src/components/messages/analysesModel';
import config from 'src/config';

class PatientsAnalysesAnalysesModel extends MessageAnalysesModel {
  id = 'PatientsAnalysesAnalysesModel';

  _events = {
    profile: 'handleProfile',
    openPatientAnalyse: 'onOpenPatient',
    'foxsocket:message:analyse': 'onMessage'
  };
  handleProfile = (profile) => {
    this.setState({ user: profile });
  };

  listParams(loadMore) {
    const req = super.listParams(loadMore);

    if (!req) return null;

    return {
      ...req,
      patientId: req.partnerId
    };
  }
  onOpenPatient = (patient = null) => {
    if (!patient?.id) return;

    this.onOpenContact({
      contact: {
        ...patient,
        partnerId: patient.id
      }
    });
  };

  canModify = (item) => {
    return (
      item.createdById === this.state.user?.id &&
      item.date > Date.now() - config.get('removeAnalysesTime')
    );
  };
}
const analysesModel = new PatientsAnalysesAnalysesModel();

export default analysesModel;
